import { IconPlus } from 'assets/icons';
import styled from 'styled-components';

const BookingHeaderContainer = styled.div<{ $hasDeliveryItem: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  /* position: sticky;
  top: 57px; */

  z-index: 13;

  width: 100%;
  padding: ${({ $hasDeliveryItem }) =>
    $hasDeliveryItem ? '32px 20px' : '32px 20px 8px'};

  background-color: #fff;

  @media (max-width: 768px) {
    top: 0px;

    padding: ${({ $hasDeliveryItem }) =>
      $hasDeliveryItem ? '24px 20px' : '24px 20px 8px'};
  }

  > h3 {
    margin: 0;

    font-weight: 500;
    font-size: 24px;
    line-height: 32px;

    color: rgba(27, 28, 30, 1);
  }
`;

const AddScheduleButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;

  padding: 0 12px;

  border-radius: 12px;

  font-weight: 600;
  font-size: 14px;
  line-height: 36px;

  cursor: pointer;

  ${({ $isActive }) => `
    background-color: ${
      $isActive ? 'rgba(0, 113, 233, 1)' : 'rgba(244, 244, 245, 1)'
    };
    color: ${$isActive ? 'rgba(255, 255, 255, 1)' : 'rgba(219, 220, 223, 1)'};
  `}
`;

interface BookingHeaderProps {
  handleAddingScheduleModal: () => void;
  totalUnFixedTicketCount: number;
  hasDeliveryItem: boolean;
  initBookingId: () => void;
}

function BookingHeader({
  handleAddingScheduleModal,
  totalUnFixedTicketCount,
  hasDeliveryItem,
  initBookingId,
}: BookingHeaderProps) {
  const isActive = totalUnFixedTicketCount > 0;

  const onClickAddingScheduleButton = () => {
    if (isActive) {
      initBookingId();
      handleAddingScheduleModal();
    }
  };

  return (
    <BookingHeaderContainer $hasDeliveryItem={hasDeliveryItem}>
      <h3>예약</h3>

      <AddScheduleButton
        $isActive={isActive}
        onClick={onClickAddingScheduleButton}
      >
        <IconPlus />
        {`일정조율형 예약확정 ${
          totalUnFixedTicketCount?.toLocaleString() || 0
        }건`}
      </AddScheduleButton>
    </BookingHeaderContainer>
  );
}

export default BookingHeader;
